import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type BrandingFormRows = {
  label: string;
  id: vp.BrandingId;
  type: 'checkbox' | 'color' | 'inputfile';
};

export const useBuildBrandingFormRows = (): BrandingFormRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Settings.Branding' });
  return [
    {
      label: t('logoLabel'),
      id: vp.BrandingId.Logo,
      type: 'inputfile',
    },
    {
      label: t('smallLogoLabel'),
      id: vp.BrandingId.SmallLogo,
      type: 'inputfile',
    },
    {
      label: t('primaryColorLabel'),
      id: vp.BrandingId.PrimaryColor,
      type: 'color',
    },
    {
      label: t('secondaryColorLabel'),
      id: vp.BrandingId.SecondaryColor,
      type: 'color',
    },
    {
      label: t('applyToAllLabel'),
      id: vp.BrandingId.ApplyToAll,
      type: 'checkbox',
    },
  ];
};
